import FieldTextIcon from '@atlaskit/icon-lab/core/field-text';
import * as React from 'react';

export function SvgHighlightText() {
  return <FieldTextIcon label="" testId="ads-refreshed-icon" />;
}
